import { useTranslation } from 'next-i18next';
import { ApiUserSubscriptionPaymentDetailsOk } from '@type/v1-api-types/user-subscription';


// Interface
// *****************************************************
interface NextSubscriptionPaymentProps {
  paymentDetails?: ApiUserSubscriptionPaymentDetailsOk;
}


/**
 * @description Next Subscription Payment component.
 * - **paymentDetails**: Payment details.
 */
export const NextSubscriptionPayment = (props: NextSubscriptionPaymentProps) => {
  // Destructure props
  const {
    paymentDetails,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  // Return null if no payment details
  if (!paymentDetails) return null;

  // Helper variables
  const cellClass = 'flex justify-between py-5 px-6';
  const bonusClass = paymentDetails?.priceDiscount > 0 ? 'text-secondary' : 'text-ink-light';


  // Render component
  // *************************************
  return (
    <div className="divide-y bg-surface-50">
      {/* Subscription price */}
      <div className={cellClass}>
        <p>{t('subscription-price.label')}</p>
        <p className="font-bold">{`€${paymentDetails?.recurrentPrice}`}</p>
      </div>

      {/* Neuro discount */}
      <div className={cellClass}>
        <p>{t('subscription.neuro.discount.label')}</p>
        <p className={`font-bold ${bonusClass}`}>{`€${paymentDetails?.priceDiscount}`}</p>
      </div>

      {/* Final price */}
      <div className={cellClass}>
        <p>{t('global.label.total.only')}</p>
        <p className="font-bold">{`€${paymentDetails?.price}`}</p>
      </div>
    </div>
  );
};
